import './styles/App.css';
import React from 'react';
import Calendar from './components/Calendar';

function App() {
  return (
    <div className="App">
      <Calendar />
    </div>
  );
}

export default App;
